<template>
  <div v-if="item">
    <button @click="downloadPdf" class="btn btn-info mb-4">Скачать PDF</button>
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "works",
    cardSetLink: "works",
    item: null,
    fields: [
      {
        col: "col-12 col-md-8",
        key: "title",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-4",
        key: "given_seconds",
        label: "Сколько секнуд на решение",
        type: "mask",
        mask: "###",
        textType: "number",
      },
      // {
      //   col: "col-12 col-md-12",
      //   key: "audio_document",
      //   label: "Аудио документ",
      //   type: "audio",
      // },
      {
        col: "col-12 col-md-12",
        key: "description",
        label: "Краткое описание задания",
        type: "textarea",
        textType: "text",
      },
      // {
      //       col:'col-12 col-md-12',
      //       key: "is_time_limit",
      //       label: "Есть лимит времени",
      //       type: "checkbox",
      //  },
      //   {
      //       col:'col-12 col-md-12',
      //       key: "given_seconds",
      //       label: "Сколько секнуд на решение",
      //               type: "mask",
      //       mask:'###',
      //       textType: "number",
      // },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    downloadPdf() {
      this.$loading(true);
      this.$http
        .get(`business/pdf/works/${this.item.id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.item.title;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error)
        .finally(() => {
          this.$loading(false);
        });
    },
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
